/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client'

import { useAtomValue } from 'jotai'

import { MtaKitStoryblok } from '@/lib/storyblok/types/generated-types'
import { storyAtom } from '@/store/story'

/** Expected component name for an MTa Kit, from {@link MtaKitStoryblok}. */
const MTA_KIT_COMPONENT_NAME: MtaKitStoryblok['component'] = 'mta-kit' as const

/**
 * Hook that pulls the slug (i.e. `mta-insights` or `mta-team-kit`) for the MTa Kit being browsed. Requires the user
 * to be on the product page for the MTa Kit. If the user is not on the kit, this hook will return null.
 */
const useKitSlug = (): string | null => {
  const story = useAtomValue(storyAtom)

  // Verify there is a story, and it is an MTa Kit
  if (!story || story?.content?.component !== MTA_KIT_COMPONENT_NAME) {
    return null
  }

  return story.slug
}

export { useKitSlug }
